import { render, staticRenderFns } from "./ImagenesEventos.vue?vue&type=template&id=f988ea48&scoped=true"
import script from "./ImagenesEventos.vue?vue&type=script&lang=js"
export * from "./ImagenesEventos.vue?vue&type=script&lang=js"
import style0 from "./ImagenesEventos.vue?vue&type=style&index=0&id=f988ea48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f988ea48",
  null
  
)

export default component.exports